import { CustomAttributeInputComponentModule } from '@accredible-frontend-v2/forms/custom-attribute-input';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchableSelectAnyInputComponentModule } from '../searchable-select-any-input/searchable-select-any-input.module';
import { CustomAttributeFiltersComponent } from './custom-attribute-filters.component';

@NgModule({
  declarations: [CustomAttributeFiltersComponent],
  imports: [
    CommonModule,
    CustomAttributeInputComponentModule,
    SearchableSelectAnyInputComponentModule,
  ],
  exports: [CustomAttributeFiltersComponent],
})
export class CustomAttributeFiltersComponentModule {}
